import request from "@/utils/request";

let StatisticsApi = {
    /*订单数据统计*/
    getOrderTotal(data, errorback) {
        return request._post("/merch/statistics.sales/index", data, errorback);
    },
    /*订单时间段统计*/
    getOrderByDate(data, errorback) {
        return request._post("/merch/statistics.sales/order", data, errorback);
    },
    /*商品时间段统计*/
    getGoodsByDate(data, errorback) {
        return request._post("/merch/statistics.sales/goods", data, errorback);
    },
    /*会员数据统计*/
    getUserTotal(data, errorback) {
        return request._post("/merch/statistics.user/index", data, errorback);
    },
    /*成交占比*/
    getUserScale(data, errorback) {
        return request._post("/merch/statistics.user/scale", data, errorback);
    },
    /*访问统计*/
    getVisit(data, errorback) {
        return request._post("/merch/statistics.user/visit", data, errorback);
    }
};

export default StatisticsApi;



// WEBPACK FOOTER //
// ./src/api/statistics.js